import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-open",
  "use": "icon-open-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-open\"><defs><style type=\"text/css\"></style></defs><path d=\"M855.15264 217.6H166.4c-51.2 0-51.2 51.2 0 51.2h688.77824c55.5264 0 55.5264-51.2-0.0256-51.2zM855.15264 488.96H166.4c-51.2 0-51.2 51.2 0 51.2h688.77824c55.5264 0 55.5264-51.2-0.0256-51.2zM855.15264 760.32H166.4c-51.2 0-51.2 51.2 0 51.2h688.77824c55.5264 0 55.5264-51.2-0.0256-51.2z\" p-id=\"4379\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol